import { RefBool, RefNumber } from '@tblabs/truffle';


export class Sensor
{
    public Value = new RefNumber(-1);
    public HasMalfunction = new RefBool(false);

    constructor(public Id: string, public Name: string, hasMalfunction: boolean = false) 
    { 
        this.HasMalfunction.value = hasMalfunction;
    }

    public get IsActive(): boolean
    {
        return this.Value.value > 0;
    }

    public Reset(): void
    {
        this.Value.value = (-1);
        this.HasMalfunction.value = false;
    }

    public Malfunction(isMalfunction: boolean = true): void
    {
        this.HasMalfunction.value = isMalfunction;
    }

    public SetValue(value: number): void
    {
        if (value === undefined || value === null)
        {
            return;
        }
       
        this.Value.value = value;
    }
}
